import Vue from 'vue'
import Vuex from 'vuex'
// import * as firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/storage';
///import { FirebaseAuth } from '../../../node_modules/@firebase/auth-types';
import ipLocation from 'iplocation'
Vue.use(Vuex)

export default{
    state: { 
      user:null,  
      userD:null, 
      users:null,
      observers:null,
      observerLocation:null,
      userLocation:null,
      useRoles:[
        "administrator","clerk","intervention officer","user"
      ],
      PERMISSIONS:null,
    },
    //___________________-GETTERS-_________________
    getters: { 
      getUser(state) {
        return state.user
      },  
      getUsers(state){
        return state.users
      },
      getUserByCode(state){
        return code=>{
          if (!code) {return null }
          if (!state.users) {return null}
          return state.users.find(us=>{
            return us.code == code
          })
        }
      },
      getUserByUid(state){
        return uid=>{ 
          if (!uid) {return null }
          if (!state.users) {return null} 
          return state.users.find(us=>{
            return us.key == uid
          })
        }
      },
      getUserByUid(state){
        return uid=>{ 
          if (!uid) {return null }
          if (!state.users) {return null} 
          return state.users.find(us=>{
            return us.key == uid
          })
        }
      },
      getUserD(state){
        return state.userD
      },
      getObservers(state){
        return state.observers
      },
      getObserverByCode(state){
        return code=>{
          if (!code) {return null }
          if (!state.observers) {return null}
          return state.observers.find(wd=>{
            return wd.code == code
          })
        }
      },
      getObserverLocation(state){
        return state.observerLocation
      },
      getObserverLocationByCode(state){
        return code=>{
          if (!code) {return null }
          if (!state.observerLocation) {return null}
          return state.observerLocation.find(wd=>{
            return wd.code == code
          })
        }
      },
      getLocationForObserver(state){
        return key=>{
          if (!key) {return null }
          if (!state.observerLocation) {return null}
          return state.observerLocation.filter(wd=>{
            return wd.observer_key == key
          })
        }
      },
      getUserLocation(state){
        return state.userLocation
      },
      getUserUserByCode(state){
        return code=>{
          if (!code) {return null }
          if (!state.userLocation) {return null}
          return state.userLocation.find(wd=>{
            return wd.code == code
          })
        }
      },
      getLocationForUser(state){
        return key=>{
          if (!key) {return null }
          if (!state.userLocation) {return null}
          return state.userLocation.filter(wd=>{
            return wd.observer_key == key
          })
        }
      },
      getUserRoles(state){
        return state.useRoles
      },
      getPermissions(state) {
        return state.PERMISSIONS 
      }, 
      getUserPermissionByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.PERMISSIONS){return null}
          return state.PERMISSIONS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getUserPermissionByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.PERMISSIONS){return null}
          return state.PERMISSIONS.find(ct=>{
            return ct.code == code
          }) 
        }
      },
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      updateUser(state, payload) {
        state.user = payload
      }, 
      updateUserD(state, payload) {
        state.userD = payload
      } 
       
    },
    //[____________________[ACTIONS]_____________________]
    actions: { 
      //-------------[SETTER]---------------
      //user
      setUser({ commit,state}, payload) { 
        commit('updateUser', payload)
      }, 
      //user detail
      setUserDetails({ commit,state}, payload) {  
        commit('updateUserD', payload) 
      },

      //---------------[CREATING USER]--------
      fi_createUserWithEmail({ commit,state}, payload){
        let M_USER = state.userD

        let email = payload.email
        let password = payload.password
        let name = payload.name
        let user_group_code = payload.user_group_code
        let phone = payload.phone
        let dt = new Date
        let date = dt.toISOString()

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'creating/user'
        })
        firebase.auth().createUserWithEmailAndPassword(email,password)
        .then(result=>{ 
          //add details
          let us = result.user  
          return firebase.database().ref('/USERS/' +us.uid).update({ 
            name: name ,
            password:password,
            user_group_code:user_group_code,
            email:us.email,
            uid:us.uid,
            phone:phone,
            created_at:date,
            created_by:M_USER
          })
        })
        .then(res=>{
          //sign user back
          return firebase.auth().signInWithEmailAndPassword(M_USER.email,M_USER.password)
        })
        .then(res=>{ 
          //success
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'creating/user'
          })
          commit('updateResponses', {
            res: 'creating/user/successful',
            val: res
          })

        })
        .catch(error=>{
          //error
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'creating/user'
          })
          commit('updateResponses', {
            res: 'creating/user/error',
            val: error
          })
        })
      },

      //---------------[SIGNING USER]---------
      //Email
      fi_signWithEmail({ commit}, payload){ 
        let email = payload.email
        let password = payload.password
        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: true,
          name: 'signing/withEmail'
        })
        firebase.auth().signInWithEmailAndPassword(email,password)
        .then(res=>{
          //not
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/withEmail'
          })
          commit('updateResponses', {
            res: 'signing/withEmail/successful',
            val: res
          }) 
        })
        .catch(err=>{
          //not
          console.log(err);
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/withEmail'
          })
          commit('updateResponses', {
            res: 'signing/withEmail/error',
            val: err
          }) 
        })
 
      },  

      //--------------[SIGN OUT USER]--------
      fi_signUserOut({ commit, state }) { 
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: 'add',
          name: 'signing/out'
        })
        firebase.auth().signOut()
        .then(result=>{ 
          //success
          state.user = null
          state.userD = null 
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/out'
          })
          commit('updateResponses', {
            res: 'signing/out/successful',
            val: result
          })
        }).catch(error=>{
          //error
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'signing/out'
          })
          commit('updateResponses', {
            res: 'signing/out/error',
            val: error
          })
        });
      },

      
      //---------------[UPDATE / EDIT USER]--------  
      //update
      fi_updateUser({commit,state},payload){
        let user = state.user
        let uid = user.uid
        let email= user.email 

        let name = payload.name
        let phone = payload.phone
        let password = payload.password
        let old_password = payload.old_password
        let user_group_code = payload.user_group_code

        let dt = new Date
        let date = dt.toISOString()

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: 'add',
          name: 'updating/user'
        })

        firebase.auth().signInWithEmailAndPassword(email,old_password)
        .then(res=>{ 
          if(!password){
            return null
          }
          return user.updatePassword(password)
        })
        .then(res=>{   
          if (user_group_code) { 
            return firebase.database().ref('SETTINGS/USERS/'+uid).update({ 
              name: name ,
              password:password?password:old_password, 
              phone:phone,
              user_group_code:user_group_code,
              email:email,
              updated_at:date
            })
          } else { 
            return firebase.database().ref('SETTINGS/USERS/'+uid).update({ 
              name: name ,
              password:password?password:old_password, 
              phone:phone,
              email:email,
              updated_at:date
            })
          } 
        })
        .then(res=>{ 
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'updating/user'
          })
          commit('updateResponses', {
            res: 'updating/user/successful',
            val: res
          })
        })
        .catch(error=>{ 
          //not error
          commit('updateLoading', false)
          commit('updateProcesses', {   
            name: 'updating/user'
          })
          commit('updateResponses', {
            res: 'updating/user/error',
            val: error
          })
        })
      },
      //user
      fi_editUser({commit,state},payload){
        let M_USER = state.userD
        let E_USER = null

        let name = payload.name
        let phone = payload.phone
        let email = payload.email
        let password = payload.password 
        let user_group_code = payload.user_group_code

        let dt = new Date
        let date = dt.toISOString()

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: 'add',
          name: 'editing/user'
        })

        firebase.auth().signInWithEmailAndPassword(email,password)
        .then(res=>{  
          E_USER = res.user
          return E_USER.updatePassword(password)
        })
        .then(res=>{    
          return firebase.database().ref('SETTINGS/USERS/'+E_USER.uid).update({ 
            name: name ,
            password:password?password:old_password, 
            phone:phone,
            user_group_code:user_group_code,
            email:email,
            updated_at:date
          })
        })
        .then(res=>{ 
          return firebase.auth().signInWithEmailAndPassword(M_USER.email,M_USER.password)
        })
        .then(res=>{  
          //not success
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'editing/user'
          })
          commit('updateResponses', {
            res: 'editing/user/successful',
            val: res
          })
        })
        .catch(error=>{  
          //not error
          console.log(error);
          
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'editing/user'
          })
          commit('updateResponses', {
            res: 'editing/user/error',
            val: error
          })
        })
      }, 
      //----------------[DELETE]----------
      //user
      fi_deleteUser({ commit,dispatch, state }, payload){ 
        let M_USER = state.userD
        let D_USER = null

        let password = payload.password
        let email = payload.email
        let signout = payload.signout 

        //not
        commit('updateLoading', true)
        commit('updateProcesses', {
          add: 'add',
          name: 'deleting/user'
        })
        firebase.auth().signInWithEmailAndPassword(email,password)
        .then(res=>{ 
          D_USER = res.user
          return firebase.database().ref('/SETTINGS/USERS/'+D_USER.uid).set(null)
        }) 
        .then(res=>{  
          return D_USER.delete()
        }) 
        .then(res=>{
          if (signout) { 
            state.userD = null
            state.users = null
            state.user = null
            return null
          }else{ 
            return firebase.auth().signInWithEmailAndPassword(M_USER.email,M_USER.password)
          }
        })
        .then(res=>{ 
          //success
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/user'
          })
          commit('updateResponses', {
            res: 'deleting/user/successful',
            val: res
          })
          //dispatch('fi_signOut')
        })
        .catch(error=>{ 
          //error
          console.log(error);
          commit('updateLoading', false)
          commit('updateProcesses', { 
            name: 'deleting/user'
          })
          commit('updateResponses', {
            res: 'deleting/user/error',
            val: error
          })
        })
      },

      //-----------------[ FI GET ]--------------\
      fi_getOn_userD({commit,state}){
        commit('updateProcesses', {
          add: true,
          name: 'getting/usersDetail'
        }) 
        let uid = state.user.uid
        let ref = firebase.database().ref('SETTINGS/USERS/'+uid)
        ref.on('value',data=>{
          commit('updateProcesses', {  
            name: 'getting/usersDetail'
          })
          let obj = data.val()
           
          state.userD = obj   
        })
      },
      fi_getOn_users({commit,state}){
        commit('updateProcesses', {
          add: true,
          name: 'getting/users'
        }) 
        let ref = firebase.database().ref('SETTINGS/USERS/')
        ref.on('value',data=>{
          commit('updateProcesses', {  
            name: 'getting/users'
          })
          let obj = data.val()
          let user = []
          let i = 1
          for (const key in obj) {
            let sms = obj[key] 
            user.push({
              i:i,
              key:key,
              ...sms
            })
            i++
          }
          state.users = user   
        })
      }, 
      fi_getOn_observers({commit,state}){
        commit('updateProcesses', {
          add: true,
          name: 'getting/observers'
        }) 
        let ref = firebase.database().ref('/SETTINGS/OBSERVER/')
        ref.on('value',data=>{
          commit('updateProcesses', {  
            name: 'getting/observers'
          })
          let obj = data.val()
          let observer = []
          let i = 1
          for (const key in obj) {
            let sms = obj[key] 
            observer.push({
              i:i,
              key:key,
              ...sms
            })
            i++
          }
          state.observers = observer   
        })
      },
      fi_getOn_observerLocations({commit,state}){
        commit('updateProcesses', {
          add: true,
          name: 'getting/observerLocation'
        }) 
        let ref = firebase.database().ref('/SETTINGS/OBSERVER_LOCATION/')
        ref.on('value',data=>{
          commit('updateProcesses', {  
            name: 'getting/observerLocation'
          })
          let obj = data.val()
          let observer = []
          let i = 1
          for (const key in obj) {
            let sms = obj[key] 
            observer.push({
              i:i,
              key:key,
              ...sms
            })
            i++
          }
          state.observerLocation = observer   
        })
      },
      fi_getOn_userLocations({commit,state}){
        commit('updateProcesses', {
          add: true,
          name: 'getting/userLocation'
        }) 
        let ref = firebase.database().ref('/SETTINGS/USER_LOCATION/')
        ref.on('value',data=>{
          commit('updateProcesses', {  
            name: 'getting/userLocation'
          })
          let obj = data.val()
          let observer = []
          let i = 1
          for (const key in obj) {
            let sms = obj[key] 
            observer.push({
              i:i,
              key:key,
              ...sms
            })
            i++
          }
          state.userLocation = observer   
        })
      },
        
    },
}
